export const NAMESPACE = 'info-box';

export const InfoBoxClassName = {
  WINDOW: `${NAMESPACE}-window`,
  ARROW: `${NAMESPACE}-arrow`,
  BODY: `${NAMESPACE}-body`,
  MOBILE_WRAPPER: `${NAMESPACE}-mobile-wrapper`,
  MOBILE_WRAPPER_OPEN: 'overflow-hidden',
  BOX_POPOVER: `${NAMESPACE}-popover`,
  BOX_FORCED: `${NAMESPACE}-forced`,
  BOX_GRID: `${NAMESPACE}-grid`,
  BOX_GRID_POSITIONED: `${NAMESPACE}-grid-positioned`,
  HAS_CENTERED_ARROW: 'has-centered-arrow',
  OPACITY: 'opacity-20',
  SHOWING: 'showing',
  IS_SHOWN: 'is-shown',
  IS_HIDING: 'is-hiding',
  IS_ACTIVE: 'active',
  FIXED_WITH: 'fixed-width',
  IN_STICKY_PARENT: `${NAMESPACE}-in-sticky-parent`
};

export const Placement = {
  vertical: 'vertical',
  horizontal: 'horizontal'
} as const;

export type PlacementType = typeof Placement[keyof typeof Placement];
